// extracted by mini-css-extract-plugin
export default {"btnContainer":"menu-lateral-btn_btnContainer__gBiUh","icon":"menu-lateral-btn_icon__AnPIy","seta":"menu-lateral-btn_seta__9F3TY"};